import type { ReduxApplicationState } from '../combinedReducer';

export const selectUser = (state: ReduxApplicationState) => state.user;
